import React from 'react';
import PropTypes from 'prop-types';

class NewsletterForm extends React.PureComponent {
  static propTypes = {};
  static defaultProps = {};

  componentDidMount() {
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.charset = 'utf-8';
    scriptTag.src =
      'https://prochurchtools.activehosted.com/f/embed.php?id=190';
    scriptTag.async = true;
    this.containerDiv.appendChild(scriptTag);
  }

  render() {
    return (
      <div ref={el => (this.containerDiv = el)} style={{ textAlign: 'center' }}>
        <div className="_form_190" />
      </div>
    );
  }
}

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/components/NewsletterForm/NewsletterForm.js